import { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useUserContext } from '@/UserContext'

// The user state sessionId should be changed for each Muse session. This
// effect can be used on pages like Host or Join so that a new ID is generated
// before joining the room.
export function useRecycleSessionId() {
    const [_userState, userDispatch] = useUserContext()

    useEffect(() => {
        let newId = uuidv4()
        userDispatch({
            type: 'set_app_ids',
            value: {
                sessionId: newId,
            },
        })
    }, [])
}
